import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MunicipalityService } from "../../../services/data/municipality.service";
import { ProvinceService } from "../../../services/data/province.service";
import { ActualSelected, Utils } from "../../../shared/utils";
import { ValueService } from "../../../shared/value.service";
import { BankAccountModel } from "../../finanzas/bancos/bankaccount.model";
import { BankAccountService } from "../../finanzas/bancos/bankaccount.service";
import { ModelTaxService } from "../model-tax.service";
import * as FileSaver from "file-saver";
import { Taxes180Model } from "./taxes-180.model";
import { consts } from "../../../consts";
import { Option } from "../../../shared/models/option.model";

@Component({
    selector: "convfact-model180",
    templateUrl: "./model-180.component.html",
    styleUrls: ["./model-180.component.css"],
    standalone: false
})
export class Model180Component implements OnInit {
  title = "Modelo 180 - Declaración de retenciones por capital inmobiliario";

  KEY_PATH = "PATH_URL_MODEL_180";

  public data: Taxes180Model = new Taxes180Model();
  validations: any[] = [];

  public isLoading: boolean = false;

  path: string = "";

  bankAccounts: BankAccountModel[] = [];

  provinces: any[] = [];
  municipalities: any[] = [];
  street_types: any[] = [];
  locations_types: any[] = [];
  numbering_types: any[] = [];
  modalities: any[] = [];
  selectedPerceptor: any = null;
  selectedIndex: number = -1;

  situacionInmuebleOptions: Option[] = [
    { label: "1", value: "1" },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
  ];

  constructor(
    public snackBar: MatSnackBar,
    private modelTaxService: ModelTaxService<Taxes180Model>,
    private valueService: ValueService,
    private bankAccountService: BankAccountService,
    private provinceService: ProvinceService,
    private municipalityService: MunicipalityService,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.getPath();

    Promise.all([
      this.valueService.getList("STREET_TYPE").then((r) => (this.street_types = r.data)),
      this.valueService.getList("LOCATION_TYPE").then((r) => (this.locations_types = r.data)),
      this.valueService.getList("NUMBERING_TYPE").then((r) => (this.numbering_types = r.data)),
      this.valueService.getList("OPERATION_MODALITY").then((r) => (this.modalities = r.data)),
    ])
      .then(() => {
        this.loadProvinces();
        return Promise.all([this.getData(), this.getBankAccounts()]);
      })
      .then(() => {
        if (!this.data) return;
        if (!this.data.contact) this.data.contact = {} as any;
        if (!this.data.ejercicio) this.data.ejercicio = String(ActualSelected.yearSelected);
        if (!this.data.periodo) this.data.periodo = "A";

        if (!this.data.page1_Num_5_8) this.data.page1_Num_5_8 = String(ActualSelected.yearSelected);
        if (!this.data.page1_Num_108_120) this.data.page1_Num_108_120 = "1800000000000";


        if (this.data.contact && this.data.contact.provinceCode) {
          this.onChangeProvince();
        }
      })
      .catch(() => {
        this.displayInfo("Ha ocurrido un error cargando datos auxiliares");
      })
      .finally(() => {

      });
  }

  getData(): Promise<void> {
    this.isLoading = true;
    const receiptNumber = null;
    return this.modelTaxService
      .getData({ period: "A", receiptNumber }, this.data)
      .then((response) => {
        this.data = response;
        if (!this.data.perceptores) this.data.perceptores = [];
        if (this.data && this.data.contact && this.data.contact.provinceCode) {
          this.onChangeProvince();
        }
      })
      .catch(() => {
        this.displayInfo("Ha ocurrido un error inesperado al obtener la información");
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  loadProvinces() {
    this.provinceService.getList().subscribe((response) => {
      this.provinces = response.data;
    });
  }

  onChangeProvince() {
    let prov = null;
    if (this.data && this.data.contact && this.data.contact.provinceCode) {
      prov = this.data.contact.provinceCode;
    }
    
    if (!prov) {
      this.municipalities = [];
      return;
    }
    this.municipalityService.getList({ province_code: prov }).subscribe((response) => {
      this.municipalities = response.data;
    });
  }
  public getFile() {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }
    this.isLoading = true;

    this.data.periodo = "A";
    this.data.ejercicio = this.data.ejercicio || String(ActualSelected.yearSelected);
    this.data.page1_Num_5_8 = this.data.page1_Num_5_8 || this.data.ejercicio;
    if (!this.data.page1_Num_108_120) this.data.page1_Num_108_120 = "1800000000000";
    this.modelTaxService
      .getFileTxt(this.data)
      .then((blob: Blob) => {
        const year = (this.data as any).year || this.data.ejercicio || this.data.page1_Num_5_8;
        FileSaver.saveAs(blob, `${year}_${this.data.periodo}.txt`);
      })
      .catch(() => {
        this.displayInfo("Ha ocurrido un error inesperado al obtener la información");
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
  getPath() {
    this.valueService.getValue(this.KEY_PATH).then((response) => {
      this.path = response.data.data;
    });
  }

  validate() {
    this.isLoading = true;

    this.data.periodo = "0A";
    this.data.ejercicio = this.data.ejercicio || String(ActualSelected.yearSelected);
    this.data.page1_Num_5_8 = this.data.page1_Num_5_8 || this.data.ejercicio;

    this.modelTaxService
      .validate(this.data)
      .then((response: any) => {
        this.validations = response || [];
      })
      .catch(() => {
        this.displayInfo("Ha ocurrido un error inesperado al obtener la información");
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  private displayInfo(response: string): void {
    const options: MatSnackBarConfig = { duration: 10500 };
    this.snackBar.open(response, "", options);
  }

  redirectFileTax() {
    if (!this.path) return;
    window.open(this.path, "_blank");
  }

  scrollToElement(key: string) {
    const element = document.getElementById(key);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  getBankAccounts(): Promise<void> {
    return this.bankAccountService.getList().then((response) => {
      this.bankAccounts = response.list;
    });
  }

  formatDate(date: Date): string | null {
    if (!date) return null;
    const year = date.getFullYear();
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const day = ("0" + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  openModal(templateRef: any) {
    this.dialog.open(templateRef, {
      height: "95vh",
      width: "100vh",
    });
  }
  private newPerceptor(): any {
    return {
      nifPerceptor: "",
      nifRepresentante: "",
      nombrePerceptor: "",
      ejercicioDevengo: "0000",
      codigoProvinciaPerceptor: "",
      modalidad: "1",
      baseAnual: 0,
      porcentajeRetencion: 0,
      retencionAnual: 0,
      situacionInmueble: "4",
      referenciaCatastral: "",
      streetTypeId: null,
      address: "",
      numberingTypeId: null,
      number: "",
      numberQualifier: "",
      block: "",
      entrance: "",
      staircase: "",
      floor: "",
      door: "",
      complement: "",
      locationId: null,
      municipio: "",
      localidad: "",
      streetTypeDesc: "",
      numberingTypeDesc: "",
      municipalityCode: "",
      provinceCode: "",
      postalCode: "",
    };
  }


  openAddPerceptor(templateRef: any) {
    if (!this.data.perceptores) this.data.perceptores = [];
    this.selectedIndex = -1;
    this.selectedPerceptor = this.newPerceptor();
    this.openModal(templateRef);
    this.onChangeProvinceModal();
  }

  openEditPerceptor(templateRef: any, p: any, index: number) {
    this.selectedIndex = index;
    this.selectedPerceptor = Object.assign(this.newPerceptor(), p);
    this.openModal(templateRef);
    this.onChangeProvinceModal();
  }


  savePerceptor() {
  if (!this.data.perceptores) this.data.perceptores = [];

  // Obligatorios del modelo
  this.selectedPerceptor.modalidad = "1";
  if (!this.selectedPerceptor.ejercicioDevengo) this.selectedPerceptor.ejercicioDevengo = "0000";

  // ✅ 1) MUNICIPIO / LOCALIDAD (texto) desde municipalityCode
  const code = (this.selectedPerceptor && this.selectedPerceptor.municipalityCode)
    ? this.selectedPerceptor.municipalityCode
    : "";

  if (!code) {
    this.selectedPerceptor.municipio = "";
    this.selectedPerceptor.localidad = "";
  } else {
    let m = null;
    for (let i = 0; i < (this.municipalities || []).length; i++) {
      const x = this.municipalities[i];
      const c = (x.municipalityCode != null) ? x.municipalityCode : ((x.code != null) ? x.code : x.id);
      if (String(c) === String(code)) { m = x; break; }
    }

    let name = "";
    if (m) {
      name = (m.municipalityName != null) ? m.municipalityName : ((m.name != null) ? m.name : ((m.description != null) ? m.description : ""));
    }

    // quieres que sean iguales:
    this.selectedPerceptor.municipio = String(name || "");
    this.selectedPerceptor.localidad = String(name || "");
  }

  // ✅ 2) TIPO DE VÍA (texto) desde streetTypeId => streetTypeDesc
  let st = null;
  for (let j = 0; j < (this.street_types || []).length; j++) {
    const s = this.street_types[j];
    if (String(s.id) === String(this.selectedPerceptor.streetTypeId)) { st = s; break; }
  }
  this.selectedPerceptor.streetTypeDesc = st
    ? String(st.description || st.name || st.text || st.key || "")
    : "";

  // ✅ 3) TIPO NUMERACIÓN (texto) desde numberingTypeId => numberingTypeDesc
  let nt = null;
  for (let k = 0; k < (this.numbering_types || []).length; k++) {
    const n = this.numbering_types[k];
    if (String(n.id) === String(this.selectedPerceptor.numberingTypeId)) { nt = n; break; }
  }
  this.selectedPerceptor.numberingTypeDesc = nt
    ? String(nt.description || nt.name || nt.text || nt.key || "")
    : "";

  // Guardar
  if (this.selectedIndex >= 0) {
    this.data.perceptores[this.selectedIndex] = Object.assign({}, this.selectedPerceptor);
  } else {
    this.data.perceptores.push(Object.assign({}, this.selectedPerceptor));
  }

  this.recalcResumen();
  this.closeModal();
}



  deletePerceptor(index: number) {
    if (!this.data.perceptores) return;
    this.data.perceptores.splice(index, 1);
    this.recalcResumen();
  }


  onChangeProvinceModal() {
    if (!this.selectedPerceptor) return;
    const prov = this.selectedPerceptor.provinceCode;
    this.selectedPerceptor.municipalityCode = "";
    this.selectedPerceptor.municipio = "";
    this.selectedPerceptor.localidad = "";
    if (!prov) {
      this.municipalities = [];
      return;
    }
    const self = this;
    this.municipalityService.getList({ province_code: prov }).subscribe(function (response: any) {
      self.municipalities = response.data;
    });
  }


  onChangeMunicipalityModal() {

  const code = (this.selectedPerceptor && this.selectedPerceptor.municipalityCode)
    ? this.selectedPerceptor.municipalityCode
    : "";

  if (!code) {
    if (this.selectedPerceptor) {
      this.selectedPerceptor.municipio = "";
      this.selectedPerceptor.localidad = "";
    }
    return;
  }

  let name = "";

  for (let i = 0; i < (this.municipalities || []).length; i++) {

    const x = this.municipalities[i];

    let c = "";
    if (x.municipalityCode != null) c = x.municipalityCode;
    else if (x.code != null) c = x.code;
    else if (x.id != null) c = x.id;

    if (String(c) === String(code)) {

      if (x.municipalityName != null) name = x.municipalityName;
      else if (x.name != null) name = x.name;
      else if (x.description != null) name = x.description;

      break;
    }
  }

  if (this.selectedPerceptor) {
    this.selectedPerceptor.municipio = String(name || "");
    this.selectedPerceptor.localidad = String(name || "");
  }
}




  private recalcResumen() {
    if (!this.data.perceptores) this.data.perceptores = [];
    this.data.page1_Num_136_144 = this.data.perceptores.length;
    this.data.page1_Num_145_160 = this.data.perceptores.reduce((a, p) => a + (+p.baseAnual || 0), 0);
    this.data.page1_Num_161_175 = this.data.perceptores.reduce((a, p) => a + (+p.retencionAnual || 0), 0);
  }

  closeModal() {
    this.dialog.closeAll();
  }
  public trackByIndex(i: number) { return i; }

}
